module.exports = __webpack_public_path__ + "images/instructor-ken-jee-mobile.webp";